export const paginatorConfig = {
  initialPageSize: 10,
  pageSizeOptions: [5, 10, 25],
  showFirstLastButtons: true,
};
